<div class="d-flex flex-wrap align-items-center document-flags" (click)="$event.stopPropagation()">
  <app-document-flag-chip *ngFor="let flag of visibleFlags" [flag]="flag"></app-document-flag-chip>
  <span *ngIf="hiddenFlags.length" class="badge rounded-pill badge-primary cursor-pointer flag-more" [ngbPopover]="moreFlags" container="body">
    +{{ hiddenFlags.length }}
  </span>
  <ng-template #moreFlags>
    <div class="d-flex flex-wrap document-flags">
      <app-document-flag-chip *ngFor="let flag of hiddenFlags" [flag]="flag"></app-document-flag-chip>
    </div>
  </ng-template>

  <div *ngIf="editable && ((hasActiveFlags$ | async) || flags?.length)" ngbDropdown container="body" autoClose="outside" (openChange)="onPickerOpenChange($event)">
    <button type="button" class="badge rounded-pill flag-add-button" ngbDropdownToggle
            [class.icon-only]="flags?.length"
            [ngbTooltip]="flags?.length ? ('freightDocument.flags.edit' | transloco) : null">
      <fa-icon [icon]="plusIcon"></fa-icon>
      <span *ngIf="!flags?.length" class="ms-1">{{ 'freightDocument.flags.add' | transloco }}</span>
    </button>
    <div ngbDropdownMenu class="document-flags-menu">
      <ng-container *ngIf="availableFlags$ | async as availableFlags; else loading">
        <label *ngFor="let flag of availableFlags" ngbDropdownItem class="document-flags-option cursor-pointer">
          <input type="checkbox" class="form-check-input m-0" [checked]="hasFlag(flag)" [disabled]="pendingFlagIds.has(flag.flagId)" (change)="toggle(flag)">
          <app-document-flag-chip [flag]="flag"></app-document-flag-chip>
        </label>
        <span *ngIf="!availableFlags.length" class="dropdown-item-text text-muted document-flags-empty">
          {{ 'freightDocument.flags.noneAvailable' | transloco }}
        </span>
      </ng-container>
      <ng-template #loading>
        <span class="dropdown-item-text text-muted">{{ 'freightDocument.flags.loading' | transloco }}</span>
      </ng-template>
    </div>
  </div>
</div>
